/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of IBM                              */
/*                                                                   */
/* (C) Copyright IBM Corp. 2022                                      */
/*                                                                   */
/* ***************************************************************** */
import {fixup_server_url} from "./locate-mdx-proxy-url";
import {force_array, get} from "../utils";

/**
 * Send a request to MDX-PROXY for drug interaction
 * @param drugs - list of interacting drugs
 * @returns {Promise<Response>}
 */
export function getDrugInteractionPromise(
    {
        drugs,
        allergies,
        login_page
    }
) {
    const method = 'getDrugInteractionPromise'
    console.debug(method+": ENTER Drugs="+drugs)
    drugs = force_array(drugs);
    allergies = force_array(allergies);
    const request_body = JSON.stringify({
        drugs,
        allergies
    })

    console.debug(method+": request_body=",request_body)

    console.debug( method + ' : login_page=',login_page)

    const proxy_url = fixup_server_url('/api/drugInteractionData')

    const cookie_session = get(login_page, 'mdxAuthenticationJson.Set-Cookie', '')

    // return a Promise
    return fetch( proxy_url,
        {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authCookie': cookie_session
            },
            credentials: 'include',
            mode: 'cors',
            method: 'POST',
            body: JSON.stringify({
                drugs: drugs,
                allergies: allergies
            })
        })
}

/**
 * Fetches drug interaction details from the backend.
 * 
 * NOTE: contentSet parameter removed as of NEW backend flow (2026).
 * REASON: MDX-Services backend now routes ALL requests to DrugInteractionSvc (ContentSet-164)
 * regardless of drug/allergy combinations. The contentSet: "DI" parameter is no longer used
 * for routing decisions. Backend always calls retrieveDIDocument() unconditionally.
 * 
 * OLD FLOW: UI passed contentSet → Backend checked it → Routed to DI or General service
 * NEW FLOW: UI doesn't pass contentSet → Backend ignores it → Always routes to DI service
 * 
 * @param {Array<string>} warning_ids - Array of warning IDs to fetch details for
 * @param {Object} login_page - Login page object containing authentication cookie
 * @returns {Promise<Response>} Promise that resolves to the fetch response
 */
export function getDrugInteractiondetailsPromise(
    {warning_ids}, login_page  // contentSet parameter removed - not needed anymore
){
    const method = 'getDrugInteractiondetailsPromise'
    console.debug(method+":Enter warning ids" +warning_ids)
    
    // Simple request body - no contentSet needed
    // Backend routes all requests to DrugInteractionSvc (ContentSet-164)
    const requestBody = { warning_ids };
    const request_body = JSON.stringify(requestBody);
    
    console.debug(method+": request_body="+request_body)
    const proxy_url = fixup_server_url('/api/drugInteractionDetails')
    const cookie_session = get(login_page, 'mdxAuthenticationJson.Set-Cookie', '')
    //return promise
    return fetch( proxy_url,
        {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authCookie': cookie_session
            },
            credentials: 'include',
            mode: 'cors',
            method: 'POST',
            body: request_body
        })
}
